// ================================================================ //
// -- Font Sizes

export const MINIMUM_FONT_SIZE = 12;
export const MAXIMUM_FONT_SIZE = 18;
export const FONT_SCALE_FACTOR = 50; // Increase to reduce the size

export const CHART_BODY_FONT_SIZES = {
  X_SMALL: 11.5,
  SMALL: 12,
  MEDIUM: 14,
  LARGE: 16,
};

// ================================================================ //
// -- Font Families

export const CHART_FONTS_CORP = "'Roboto', 'Helvetica', 'Arial', 'sans-serif'";
export const CHART_FONTS_LEGACY = "'Arial', 'sans-serif'";

// ================================================================ //
// -- Chart Colors

export const CHART_COLORS_CORP = [
  '#29254f',
  '#ffd000',
  '#06748c',
  '#78e1e1',
  '#99e5ea',
  '#aaeded',
  '#c9f3f4',
  '#f2fcfc',
  '#1a1446',
  '#f5f5f5',
  '#e6e6e6',
  '#c0bfc0',
  '#707070',
  '#404040',
  '#343741',
  '#565656',
];

export const CHART_COLORS_LEGACY = [
  '#df8e44',
  '#335182',
  '#003fa5',
  '#cccccc',
  '#dddddd',
  '#dbdbdb',
  '#eeeeee',
  '#f5f5f5',
  '#333333',
  '#777777',
];

// ================================================================ //
// -- Label Colors

export const DARK_BLUE = '#1a1446';
export const WHITE = '#ffffff';
